.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.card {
  padding: 24px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: rgba(12, 10, 20, 0.6);
}

.icon {
  margin-bottom: 14px;
  font-size: 18px;
  color: var(--color-purple-bright);
}

.cardTitle {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
}

.cardText {
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-text-muted);
}

@media (max-width: 900px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
